import React, { useState } from "react"
import { connect } from "react-redux"
import styled from "styled-components"
import imageUpload, { imageType } from "../../../methods/imageUpload"
import { message } from "antd"
import { useHistory } from "react-router-dom"
import { TOPBAR_HEIGHT } from "../../../data/style"
import videoPlaceholderBlue from "../../../images/video-placeholder-blue.svg"

// 重用声音克隆页面的样式组件
const Container = styled.div`
  top: ${TOPBAR_HEIGHT}px;
  height: calc(100vh - ${TOPBAR_HEIGHT}px);
  background-color: #f8f8f8;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const MainContent = styled.div`
  flex: 1;
  padding: 20px 40px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const TitleSection = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  min-height: 50px;
`

const MainTitle = styled.h1`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 28px;
  color: #333;
  font-weight: bold;
  margin: 0;
`

const BackButton = styled.div`
  background: #fff;
  border: 1px solid #eee;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  padding: 10px 20px;
  border-radius: 50px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  /* &:hover {
    background: #f8f9fa;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  } */
`

const AiNotice = styled.div`
  text-align: center;
  margin-bottom: 16px;
  
  .ai-note {
    font-size: 14px;
    color: #666;
  }
`

// 新增横屏主体布局
const MainLayout = styled.div`
  display: flex;
  gap: 40px;
  align-items: stretch;
  flex: 1;
  max-height: calc(100vh - ${TOPBAR_HEIGHT}px - 120px);
  overflow: hidden;
`

const LeftPanel = styled.div`
  flex: 0 0 auto;
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

const RightPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  overflow: auto;
`

const TipsSection = styled.div`
  background: white;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
`

const TipItem = styled.div`
  margin-bottom: 24px;
  line-height: 1.6;
  
  &:last-child {
    margin-bottom: 0;
  }
`

const TipLabel = styled.span`
  font-size: 14px;
  color: #333;
  font-weight: bold;
`

const TipText = styled.span`
  font-size: 14px;
  color: #666;
  margin-left: 8px;
`

const VideoContent = styled.div`
  background: white;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 16px;
  min-height: 200px;
  max-height: 400px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  overflow: hidden;
`

const VideoPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  
  .placeholder-icon {
    font-size: 60px;
    margin-bottom: 16px;
  }
  
  .placeholder-text {
    font-size: 16px;
  }
`

const VideoPreview = styled.video`
  width: 100%;
  max-width: 100%;
  max-height: 350px;
  border-radius: 12px;
  background: #000;
`

const BottomActions = styled.div`
  padding: 20px 32px 40px;
  margin-top: auto;
`

const ReadySection = styled.div`
  text-align: center;
`

const ActionButtons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
`

const UploadLabel = styled.label`
  padding: 16px 32px;
  border: 2px solid var(--theme-main);
  border-radius: 25px;
  background: white;
  color: var(--theme-main);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-block;
  
  &:hover {
    background: var(--theme-main);
    color: white;
  }
  
  input {
    display: none;
  }
`

const SelectedSection = styled.div`
  text-align: center;
`

const SelectedActions = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 24px;
`

const ActionButton = styled.button`
  padding: 12px 24px;
  border: 1px solid var(--theme-main);
  border-radius: 25px;
  background: white;
  color: var(--theme-main);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background: var(--theme-main);
    color: white;
  }
  
  &.primary {
    background: var(--theme-main);
    color: white;
    
    &:hover {
      background: var(--theme-main-hover-deep);
    }
  }
  
  &.danger {
    border-color: #ff4757;
    color: #ff4757;
    
    &:hover {
      background: #ff4757;
      color: white;
    }
  }
`

const UploadingSection = styled.div`
  text-align: center;
`

const UploadingTip = styled.div`
  font-size: 14px;
  color: #333;
  margin-bottom: 32px;
`

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--theme-main);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`

const CompleteSection = styled.div`
  text-align: center;
`

const CompleteTip = styled.div`
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
`

const SuccessInfo = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
`

const ErrorSection = styled.div`
  text-align: center;
`

const ErrorTip = styled.div`
  font-size: 14px;
  color: #ff4757;
  margin-bottom: 24px;
`

interface VideoFile {
  filename?: string;
  url?: string;
  file?: File;
}

interface VideoClonePageProps {
  user?: any;
}

function VideoClonePage(props: VideoClonePageProps) {
  const [messageApi, contextHolder] = message.useMessage()
  const history = useHistory()
  
  const [uploadStatus, setUploadStatus] = useState<'ready' | 'selected' | 'uploading' | 'complete' | 'error'>('ready')
  const [selectedVideo, setSelectedVideo] = useState<(imageType & VideoFile) | null>(null)
  const [videoPath, setVideoPath] = useState<string>('')

  // 处理视频选择
  const handleVideoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files
    if (!files || files.length === 0) return

    const file = files[0]
    
    // 检查文件类型
    if (!file.type.startsWith('video/')) {
      messageApi.error('请选择视频文件')
      return
    }

    // 检查文件大小 (限制为100MB)
    if (file.size > 100 * 1024 * 1024) {
      messageApi.error('视频文件大小不能超过100MB')
      return
    }

    // 创建本地预览URL
    const url = URL.createObjectURL(file)
    setVideoPath(url)
    setUploadStatus('selected')
    
    // 模拟创建文件信息
    setSelectedVideo({
      filename: file.name,
      url: url,
      file: file
    } as any)
  }

  // 上传视频
  const uploadVideo = () => {
    if (!selectedVideo?.file) return

    setUploadStatus('uploading')
    
    imageUpload(selectedVideo.file, "ipmp4")
      .then((res) => {
        console.log("upload result:", res)
        if (res.url === "") {
          setUploadStatus('error')
          messageApi.error('上传失败')
        } else {
          setSelectedVideo({ ...selectedVideo, ...res })
          setUploadStatus('complete')
          messageApi.success('上传成功')
        }
      })
      .catch((error) => {
        console.error("upload error:", error)
        setUploadStatus('error')
        messageApi.error('上传失败，请重试')
      })
  }

  // 重新选择
  const reselect = () => {
    setUploadStatus('ready')
    setSelectedVideo(null)
    setVideoPath('')
    // 清理本地URL
    if (videoPath && videoPath.startsWith('blob:')) {
      URL.revokeObjectURL(videoPath)
    }
  }

  // 继续上传 (从完成状态返回选择状态)
  const continueUpload = () => {
    setUploadStatus('ready')
    setSelectedVideo(null)
    setVideoPath('')
  }

  // 返回上一页
  const goBack = () => {
    // 清理本地URL
    if (videoPath && videoPath.startsWith('blob:')) {
      URL.revokeObjectURL(videoPath)
    }
    history.goBack()
  }

  return (
    <>
      {contextHolder}
      <Container>
        <MainContent>
          {/* 标题区域 */}
          <TitleSection>
            <BackButton onClick={goBack}>返回上一页</BackButton>
            <MainTitle>视频克隆</MainTitle>
          </TitleSection>

          {/* AI训练说明 */}
          <AiNotice>
            <div className="ai-note">上传的视频将用于AI训练</div>
          </AiNotice>

          {/* 横屏主体布局 */}
          <MainLayout>
            {/* 左侧提示面板 */}
            <LeftPanel>
              <TipsSection>
                <TipItem>
                  <TipLabel>提示1:</TipLabel>
                  <TipText>请选择一段清晰的视频，时长不超过60秒。</TipText>
                </TipItem>
                <TipItem>
                  <TipLabel>提示2:</TipLabel>
                  <TipText>视频中需要包含清晰的正面半身人像，光线充足效果更佳。</TipText>
                </TipItem>
                <TipItem>
                  <TipLabel>提示3:</TipLabel>
                  <TipText>视频文件大小不能超过100MB。</TipText>
                </TipItem>
              </TipsSection>
            </LeftPanel>

            {/* 右侧视频预览面板 */}
            <RightPanel>
              <VideoContent>
                {!videoPath ? (
                  <VideoPlaceholder>
                    <div className="placeholder-icon"><img src={videoPlaceholderBlue} alt="video placeholder" /></div>
                    <div className="placeholder-text">暂未选择视频</div>
                  </VideoPlaceholder>
                ) : (
                  <VideoPreview controls>
                    <source src={videoPath} />
                    您的浏览器不支持视频播放
                  </VideoPreview>
                )}
              </VideoContent>
            </RightPanel>
          </MainLayout>
        </MainContent>

        {/* 底部操作区域 */}
        <BottomActions>
          {/* 准备状态 */}
          {uploadStatus === 'ready' && (
            <ReadySection>
              <ActionButtons>
                <UploadLabel>
                  <input 
                    type="file" 
                    accept="video/*" 
                    onChange={handleVideoUpload} 
                  />
                  选择视频
                </UploadLabel>
              </ActionButtons>
            </ReadySection>
          )}

          {/* 已选择视频状态 */}
          {uploadStatus === 'selected' && (
            <SelectedSection>
              <SelectedActions>
                <ActionButton onClick={reselect}>重新选择</ActionButton>
                <ActionButton className="primary" onClick={uploadVideo}>上传视频</ActionButton>
              </SelectedActions>
            </SelectedSection>
          )}

          {/* 上传中状态 */}
          {uploadStatus === 'uploading' && (
            <UploadingSection>
              <UploadingTip>正在上传视频...</UploadingTip>
              <Spinner />
            </UploadingSection>
          )}

          {/* 完成状态 */}
          {uploadStatus === 'complete' && (
            <CompleteSection>
              <CompleteTip><span role="img" aria-label="check mark">✅</span> 上传完成</CompleteTip>
              {selectedVideo && (
                <SuccessInfo>{selectedVideo.filename}</SuccessInfo>
              )}
              <ActionButton className="primary" onClick={continueUpload}>继续上传</ActionButton>
            </CompleteSection>
          )}

          {/* 错误状态 */}
          {uploadStatus === 'error' && (
            <ErrorSection>
              <ErrorTip>提示：上传失败，请重试</ErrorTip>
              <ActionButton className="danger" onClick={reselect}>重新选择</ActionButton>
            </ErrorSection>
          )}
        </BottomActions>
      </Container>
    </>
  )
}

const mapStateToProps = (state: any) => ({
  user: state.login_user_data,
})

export default connect(mapStateToProps)(VideoClonePage)